import { render, staticRenderFns } from "./OutcomeCourses.vue?vue&type=template&id=308ce7d4&scoped=true&"
import script from "./OutcomeCourses.vue?vue&type=script&lang=js&"
export * from "./OutcomeCourses.vue?vue&type=script&lang=js&"
import style0 from "./OutcomeCourses.vue?vue&type=style&index=0&id=308ce7d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ce7d4",
  null
  
)

export default component.exports